var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarCalendario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sidebar_calendario",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.32,
    height: 32.32,
    viewBox: "0 0 32.32 32.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M8.04,6H26.894a4.045,4.045,0,0,1,4.04,4.04V28.894a4.045,4.045,0,0,1-4.04,4.04H8.04A4.045,4.045,0,0,1,4,28.894V10.04A4.045,4.045,0,0,1,8.04,6ZM26.894,30.24a1.348,1.348,0,0,0,1.347-1.347V10.04a1.348,1.348,0,0,0-1.347-1.347H8.04A1.348,1.348,0,0,0,6.693,10.04V28.894A1.348,1.348,0,0,0,8.04,30.24Z",
    transform: "translate(-1.307 -1.96)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M31.347,10.08A1.347,1.347,0,0,1,30,8.733V3.347a1.347,1.347,0,1,1,2.693,0V8.733A1.347,1.347,0,0,1,31.347,10.08Z",
    transform: "translate(-9.8 -0.653)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M15.347,10.08A1.347,1.347,0,0,1,14,8.733V3.347a1.347,1.347,0,0,1,2.693,0V8.733A1.347,1.347,0,0,1,15.347,10.08Z",
    transform: "translate(-4.573 -0.653)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M29.587,20.693H5.347a1.347,1.347,0,1,1,0-2.693h24.24a1.347,1.347,0,0,1,0,2.693Z",
    transform: "translate(-1.307 -5.88)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M0,0H32.32V32.32H0Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCalendario);
export default __webpack_public_path__ + "static/media/sidebar_calendario.7d15bc2c7ed6bf4e835215e0b387c4d7.svg";
export { ForwardRef as ReactComponent };